import React from 'react'
import { connect } from 'react-redux'
import { getFormValues, Field } from 'redux-form'
import {
  Fade,
} from '@material-ui/core'
import { pascal } from 'change-case'

import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import ItemTable from '../../Shareds/ItemTable'

import { 
  GRContainer,
  RowFields
} from 'routes/ProcurementSystem/GoodsServiceReceipt/styled'

const Detail = props => {

  const { valueForm } = props

  return (
    <Fade in={true} timeout={1000}>
    <GRContainer>
      <StdCard title='Detail Information'>
        {valueForm.isFinal&&
        <RowFields>
          <Field
            name='mainContractTotalValue'
            label='Main Contract Total Value'
            type={type.number}
            fixedDecimalScale={true}
            component={FieldInput}
            editable={false}
            suffix={` ${valueForm.currencyCode}`}
          />
          <Field
            name='contractNo'
            label='Contract Number'
            type={type.text}
            component={FieldInput}
            editable={false}
          />
        </RowFields>}
        <RowFields>
          <Field
            name='mainDeliveryType'
            label='Type'
            type={type.text}
            component={FieldInput}
            editable={false}
          />
          <Field
            name='subDeliveryType'
            label={`Type of ${pascal(valueForm.mainDeliveryType)}`}
            type={type.text}
            filterKey='MIGRATION'
            component={FieldInput}
            editable={false}
          />
        </RowFields>
        <RowFields>
          <Field
            name='postingDate'
            label='Posting Date'
            type={type.date}
            component={FieldInput}
            editable={false}
            className='halfRow'
          />
        </RowFields>
        <RowFields>
          <Field
            name='invoiceNumber'
            label='Invoice Number'
            type={type.text}
            component={FieldInput}
            editable={false}
          />
          <Field
            name='invoiceDate'
            label='Invoice Date'
            type={type.date}
            component={FieldInput}
            editable={false}
          />
        </RowFields>
        <RowFields>
          <Field
            name='forPeriod'
            label='For The Period'
            type={type.text}
            component={FieldInput}
            editable={false}
          />
          <Field
            name='totalPeriod'
            label='Total Period'
            type={type.text}
            component={FieldInput}
            editable={false}
          />
        </RowFields>
        <div className='headerText'>
          {
            <React.Fragment>
              {`${valueForm.vendorCode} : ${valueForm.vendorFullName} `}
              <span style={{fontSize:'1.5rem', marginLeft:'1rem'}}>{valueForm.vendorCode&&(valueForm.vendorCode.startsWith('9')||valueForm.vendorCode.startsWith('6'))?'Vendor บริษัทในเครือ กลุ่มบริษัทดีทีจีโอ':''}</span>
            {/* props.vendors.data.length ? props.vendors.data.find(x=>x.value===valueForm.vendorCode).text : '' */}
            </React.Fragment>
          }
        </div>
        <ItemTable change={props.change}/>
        <div style={{marginTop:'1rem'}}/>
        <RowFields>
          <Field
            name='remark'
            label='Remark'
            type={type.textArea}
            component={FieldInput}
            editable={false}
          />
        </RowFields>
      </StdCard>
    </GRContainer>
    </Fade>
  )   

}

const mapStateToProps = (state) => ({
  vendors:state.options.vendors,
  valueForm: getFormValues('formGR')(state)
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Detail)
